import { guestClient } from '@/api/guestClient'

const BASE = '/otp'

export const generateOtp = async (email, source) => {
  const res = await guestClient.post(`${BASE}/generate`, { email, ...(source && { source }) })
  return res.data
}

export const resendOtp = async (email, source) => {
  const res = await guestClient.post(`${BASE}/resend`, { email, ...(source && { source }) })
  return res.data
}

export const verifyOtp = async (email, otp) => {
  const res = await guestClient.post(`${BASE}/verify`, { email, otp })
  return res.data
}
